module.exports = __webpack_public_path__ + "static/assets/6613fc8e0a0b96877b2a75d2caa6afa1.png";